<template>
  <div class="list-wrapper" ref="wrapper">
    <!--滚动部分-->
    <div :class="['scroll-content', contentClassName]">
      <!--列表部分-->
      <slot></slot>
      <!--加载更多-->
      <div v-if="pullUpLoad" class="pullup-wrapper">
        <v-loading-more :isLoading="isPullUpLoad" :noMoreText="pullUpTxt" />
      </div>
    </div>
    <!--下拉刷新-->
    <div v-if="pullDownRefresh" class="pulldown-wrapper" :style="pullDownStyle" ref="pulldown">
      <div v-if="beforePullDown" class="before-trigger">上拉刷新</div>
      <div v-else class="after-trigger">
        <div v-if="pulling">
          <!--todo-->
          加载中
          <!-- <loading></loading> -->
        </div>
        <div v-else class="refresh-txt">
          <span>{{ refreshTxt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BScroll from 'better-scroll'
import { create } from '../utils'

const pullDownInitTop = -30
export default create({
  name: 'scroll',
  /**
   *  probeType
   *  click
   *  listenScroll 是否监听滚动事件
   *  listenBeforeScroll 是否监听开始滚动滚动前事件
   *  direction 滚动方向 horizontal or vertical
   *  scrollbar BScroll 滚动条参数Boolean | Object
   *  pullDownRefresh 是否开启下拉刷新 Boolean | Object { txt: '', stop： 暂停位置的距离, stopTime: 数据获取完成后停留多少时间 }
   *  pullUpLoad 是否开启上拉加载更多 Boolean | Object { txt: {more: , nomore: } }
   *  startY 初始化Y轴位置
   *  refreshDelay 数据变动后延迟多少时间后调用forceUpdate
   *  freeScroll 是否开启横向纵向滚动
   *  horizontalWidth 开启横向滚动时的maxwidth
   *  pullingDown function -> 下拉回调
   *  pullingUp   function -> 上拉回调
   *  scroll      function -> 滚动回调
   *  beforeScrollStart function -> 滚动开始回调
   */
  props: {
    contentClassName: String,
    probeType: {
      validator: v => [1, 2, 3].includes(v),
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    mouseWheel: {
      type: Boolean,
      default: true
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    listenBeforeScroll: {
      type: Boolean,
      default: false
    },
    direction: {
      validator: v => ['horizontal', 'vertical'].includes(v),
      default: 'vertical'
    },
    scrollbar: {
      type: Boolean,
      default: false
    },
    pullDownRefresh: {
      type: [Boolean, Object],
      default: false
    },
    pullUpLoad: {
      type: [Boolean, Object],
      default: false
    },
    bounce: {
      type: [Boolean, Object],
      default() {
        return {
          top: false,
          bottom: false
        }
      }
    },
    stopPropagation: Boolean,
    momentum: {
      type: Boolean,
      default: true
    },
    startY: {
      type: Number,
      default: 0
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    freeScroll: {
      type: Boolean,
      default: false
    },
    horizontalWidth: {
      type: Number,
      default: 0
    },
    pullingDown: Function,
    pullingUp: Function,
    scroll: Function,
    beforeScrollStart: Function,
    preventDefault: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    beforePullDown: true, // 显示bubble
    isRebounding: false, // 数据获取完毕 是否开始向上回弹
    isPullingDown: false, // 下拉标识
    pulling: false, // 显示loading
    isPullUpLoad: false, // 是否正在加载
    pullUpDirty: true, // 显示footer中pullUpTxt true 显示加载更多 false 没有更多数据
    bubbleY: 0, // bubble y值
    pullDownStyle: { top: `${pullDownInitTop}px` }
  }),
  computed: {
    refreshTxt: function () {
      return (this.pullDownRefresh && this.pullDownRefresh.txt) || '刷新成功'
    },
    pullUpTxt: function () {
      const moreTxt = (this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.more) || '加载更多'
      const noMoreTxt = (this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.nomore) || '已经到底了~'
      return this.pullUpDirty ? moreTxt : noMoreTxt
    }
  },
  mounted() {
    this.initScroll()
  },
  beforeDestroy() {
    this.bs && this.bs.destroy()
  },
  methods: {
    initScroll: function () {
      if (!this.$refs.wrapper) {
        return
      }
      // 如果开启freeScroll设置宽度
      // if (this.freeScroll || this.direction === 'horizontal') {
      //   this.scrollContent.style.width = this.horizontalWidth + 'px'
      // }
      let scrollCallback = this.scroll
      // 创建betterScroll
      this.bs = new BScroll(this.$refs.wrapper, {
        click: this.click,
        mouseWheel: this.mouseWheel,
        startY: this.startY,
        probeType: this.probeType,
        scrollbar: this.scrollbar,
        pullUpLoad: this.pullUpLoad,
        freeScroll: this.freeScroll,
        preventDefault: this.preventDefault,
        pullDownRefresh: this.pullDownRefresh,
        momentum: this.momentum,
        bounce: this.bounce,
        stopPropagation: this.stopPropagation,
        scrollX: this.freeScroll || this.direction === 'horizontal',
        scrollY: this.freeScroll || this.direction === 'vertical'
      })
      // 开启滚动监听到话调用父组件callback
      if (this.listenScroll) {
        this.bs.on('scroll', pos => {
          scroll(pos.x, pos.y)
          // 执行绑定的滚动回调事件
          scrollCallback && scrollCallback(pos.x, pos.y)
        })
      }
      // 向父组件派发滚动开始事件
      if (this.listenBeforeScroll) {
        this.bs.on('beforeScrollStart', pos => {
          this.beforeScrollStart(pos)
        })
      }
      // 初始化下拉刷新
      if (this.pullDownRefresh) {
        this.initPullDownRefresh()
      }
      // 初始化加载更多
      if (this.pullUpLoad) {
        this.initPullUpLoad()
      }
    },
    initPullDownRefresh: function () {
      this.bs.on('pullingDown', () => {
        this.beforePullDown = false
        this.isPullingDown = true
        this.pulling = true
        this.pullingDown()
      })
      // 监听滚动修改bubble动画
      this.bs.on('scroll', pos => {
        if (this.beforePullDown) {
          this.bubbleY = Math.max(0, pos.y + pullDownInitTop)
          this.pullDownStyle = { top: `${Math.min(pos.y + pullDownInitTop, 10)}px` }
        } else {
          this.bubbleY = 0
        }
        if (this.isRebounding) {
          // 数据获取完毕 开始向上回弹
          this.pullDownStyle = { top: `${10 - (this.pullDownRefresh.stop - pos.y)}px` }
        }
      })
    },
    initPullUpLoad: function () {
      this.bs.on('pullingUp', () => {
        this.isPullUpLoad = true
        this.pullingUp()
      })
    },
    // 观察下拉刷新或者上拉是否完成 然后调用 reboundPullDown afterPullDown 或者数据变动了或是删除了 强制刷一下BScroll
    forceUpdate: function (dirty) {
      // 如果打开了下拉刷新功能 且 再下拉状态下
      if (this.pullDownRefresh && this.isPullingDown) {
        this.pulling = false
        this.reboundPullDown().then(() => {
          this.afterPullDown()
        })
      } else if (this.pullUpLoad && this.isPullUpLoad) {
        this.isPullUpLoad = false
        this.pullUpDirty = dirty
        // 数据加载完毕后 告诉 better-scroll 数据已加载
        setTimeout(() => {
          this.bs.finishPullUp()
          this.refresh()
        }, 500)
      } else {
        this.pullUpDirty = dirty
        this.refresh()
      }
    },
    // 延迟 stopTime 毫秒后 再调用 afterPullDown 方法还原数据
    reboundPullDown: function () {
      const { stopTime = 600 } = this.pullDownRefresh
      return new Promise(resolve => {
        setTimeout(() => {
          this.isRebounding = true
          this.isPullingDown = false
          // 数据加载完毕后 调用此方法告诉 better-scroll 数据已加载
          this.bs.finishPullDown()
          resolve()
        }, stopTime)
      })
    },
    // 刷新完成后延迟700毫秒恢复
    afterPullDown: function () {
      setTimeout(() => {
        // 还原top为初始值
        this.pullDownStyle = { top: `${pullDownInitTop}px` }
        // 显示出bubble
        this.beforePullDown = true
        // 回弹标识改为false
        this.isRebounding = false
        // 数据获取结束后重新刷新下BS
        this.refresh()
      }, this.bs.options.bounceTime)
    },
    // 禁用
    disable: function () {
      this.bs && this.bs.disable()
    },

    // 启用
    enable: function () {
      this.bs && this.bs.enable()
    },

    // 刷新
    refresh: function () {
      this.bs && this.bs.refresh()
    },

    // 滚动到某位置
    scrollTo: function () {
      this.bs && this.bs.scrollTo.apply(this.bs, arguments)
    },

    // 滚动到某个dom
    scrollToElement: function () {
      this.bs && this.bs.scrollToElement.apply(this.bs, arguments)
    },

    // 销毁 解绑事件
    destroy: function () {
      this.bs && this.bs.destroy()
    },
    stop: function () {
      this.bs && this.bs.stop()
    }
  }
})
</script>
<style lang="scss" src="./index.scss"></style>
